import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { endpoint } from 'src/environments';
import {
  ContratoEncerramentoNotificacaoDTO,
  FichaCadastralDTO,
  FichaCadastralResponseDTO,
  GeneroDTO,
  PaisDTO,
  PessoaDTO,
  ReservaDTO,
  ReservaMoradorDTO,
  TipoLogradouroDTO,
} from '../types';

interface ResponseViaCep {
  cep: string;
  logradouro: string;
  complemento: string;
  bairro: string;
  localidade: string;
  uf: string;
  ibge: string;
  error?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  private url = endpoint(`/api/ficha-cadastral`);

  constructor(private http: HttpClient) {}

  getGeneros(): Observable<GeneroDTO[]> {
    return this.http.get<GeneroDTO[]>(`${this.url}/genero/todos`);
  }

  getFicha(id: string): Observable<FichaCadastralResponseDTO> {
    return this.http.get<FichaCadastralResponseDTO>(`${this.url}/${id}`);
  }

  getPessoa(id: string): Observable<PessoaDTO> {
    return this.http.get<PessoaDTO>(`${this.url}/pessoa/${id}`);
  }

  getPessoaByDoc(doc: string, typeDoc: string): Observable<PessoaDTO> {
    return this.http.get<PessoaDTO>(`${this.url}/${typeDoc}/documento/${doc}`);
  }

  putPessoa(pessoa: PessoaDTO, reservaUuid: string): Observable<PessoaDTO> {
    return this.http.put<PessoaDTO>(
      `${this.url}/${reservaUuid}/altera-pessoa}`,
      pessoa
    );
  }

  addPessoa(pessoa: PessoaDTO, reservaUuid: string): Observable<PessoaDTO> {
    return this.http.post<PessoaDTO>(
      `${this.url}/${reservaUuid}/inserir-pessoa}`,
      pessoa
    );
  }

  getTiposLogradouro(): Observable<TipoLogradouroDTO[]> {
    return this.http.get<TipoLogradouroDTO[]>(
      `${this.url}/tipo-logradouro/todos`
    );
  }

  getPaises(): Observable<PaisDTO[]> {
    return this.http.get<PaisDTO[]>(`${this.url}/todos`);
  }

  getCep(cep: string): Observable<ResponseViaCep> {
    return this.http.get<ResponseViaCep>(
      `https://viacep.com.br/ws/${cep}/json/`
    );
  }

  postFicha(ficha: FichaCadastralDTO): Observable<FichaCadastralDTO> {
    return this.http.post<FichaCadastralDTO>(`${this.url}`, ficha);
  }

  deleteMorador(moradorUuid: string): Observable<ReservaMoradorDTO> {
    return this.http.delete<ReservaMoradorDTO>(
      `${this.url}/moradores/${moradorUuid}`
    );
  }

  getReserva(uuid: string): Observable<ReservaDTO> {
    return this.http.get<ReservaDTO>(`${this.url}/reserva/${uuid}`);
  }

  salvarRespostaAtualizacaoReserva(
    payload: ContratoEncerramentoNotificacaoDTO
  ): Observable<void> {
    return this.http.post<void>(
      `${this.url}/contratos/encerramento-notificacao/resposta`,
      payload
    );
  }

  verificarNotificacao(idExterno: string) {
    return this.http.get<void>(
      `${this.url}/contratos/encerramento-notificacao/verificar-notificacao/${idExterno}`
    );
  }
}
